import "./MessagePreview.scss"
import React from "react"
import moment from "moment"
import { observer } from "mobx-react"
import { channelStore } from "../../../app/stores"
import { UserAvatar, TeamIcon, AppIcon } from "../../../lib"

const MessagePreview = ({ message, last = true, from = "slack" }) => {
  let className = "Message"
  if (last) className += " Message-last"
  if (from) className += ` Message-${from}`
  return (
    <div className={className}>
      {last &&
        (from === "app" ? (
          <AppIcon />
        ) : channelStore.behaviorSettings.avatar_config === 1 ? (
          <TeamIcon className="Avatar" size={25} />
        ) : (
          <UserAvatar className="Avatar" size={25} />
        ))}
      <div className="Message_content">
        <div className="SlackText">{message}</div>
      </div>
      {last && (
        <span className="Message_timestamp">{moment().format("h:mm A")}</span>
      )}
    </div>
  )
}

MessagePreview.displayName = "MessagePreview"

export default observer(MessagePreview)



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/MessagePreview.js